/**
 * Apply fixed position class to element when necessary scroll level is reached
*/

import EventBus from './../event-bus.js'
import jQuery from 'jquery'

class ScrollTopTarget {
    
    /**
     * Construct component
     * @param elements
    */
    constructor(elements) {
        
        /**
         * Fixed position elements
         * @type object
        */
        this.elements = elements
        
        const
            body = jQuery('body'),
            headerSel = body.data('header')
        
        /**
         * Fixed header nav
         * @type object
        */
        this.nav = headerSel ? jQuery(headerSel) : jQuery('#header-nav')
        
        this.bindEvents()
        
    }
    
    /**
     * Handle window scroll
    */
    handleScroll() {
        
        let
            element,
            anchor,
            target,
            addClass,
            bottom,
            win = jQuery(window),
            scrollPosition = win.scrollTop(),
            navHeight = this.nav.length > 0 ? this.nav.outerHeight() : 0,
            windowHeight = win.height(),
            stick
        
        this.elements.each((i, domElement) => {
            
            element = jQuery(domElement)
            
            //Cancel if element is not visible
            if (!element.is(':visible')) {
                return
            }
            
            bottom = element.data('bottom')
            anchor = element.data('scroll-target')
            
            //Set default target to scroll element itself (normally the case for sticky-top, sticky-bottom expects an anchor)
            if (!anchor) {
                target = element
            }
            else {
                target = jQuery(anchor)
            }
            
            //Set default class to add to element when scrolled in to position
            if (!addClass) {
                addClass = 'fixed-' + (bottom ? 'bottom' : 'top')
            }
            
            //Determine hether the element should stick
            stick = bottom ? ((scrollPosition + windowHeight) < (target.offset().top + target.outerHeight())) : ((scrollPosition + navHeight) >= target.offset().top);
                
            if (stick) {
                
                element.addClass(addClass)
                
                //copy height of sticky element to anchor to prevent window jumping
                if (anchor) {
                    target.height(element.outerHeight())
                }
                
                //Offset target by nav height if sticking to the top
                if (!bottom) {
                    element.css('top', navHeight)
                }
                
            }
            else {
                
                element.removeClass(addClass)
                
                //Unset copied height on anchor
                if (anchor) {
                    target.height('')
                }
                
            }
            
        })
    
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        EventBus.subscribe('run-modules', this.handleScroll.bind(this))
        jQuery(document).scroll(this.handleScroll.bind(this))
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let elements = jQuery('.scroll-top-target')
    
    if (elements.length > 0) {
        new ScrollTopTarget(elements)
    }
    
})

export default ScrollTopTarget